import { ReactNode, useMemo } from 'react';
import { StyledInteriorPackageContainer } from '~/app/compositions/sidebar/interior-packages/styles/interior-packages-style';
import { ButtonTabs } from '~/components/button-tabs/button-tabs';
import { ExtendedSelectionGroupWrapper } from '~/components/selection-card-new/extended-selection-group';
import { SelectionCardItem } from '~/graphql/types';

interface FilteredInteriorPackagesProps {
	items: Array<SelectionCardItem & { description?: ReactNode }>;
	tabs: { value: string; label: string }[];
	selectedTab: string;
	setSelectedTab: (seatType: string) => void;
}

export const FilteredInteriorPackages = ({
	items,
	tabs,
	selectedTab,
	setSelectedTab,
}: FilteredInteriorPackagesProps) => {
	const filteredItems = useMemo(
		() => (tabs.length > 1 ? items.filter((item) => item.familyName === selectedTab) : items),
		[tabs.length, items, selectedTab],
	);

	return (
		<>
			{<ButtonTabs setSelectedTab={setSelectedTab} selectedTab={selectedTab} tabs={tabs} />}
			<StyledInteriorPackageContainer>
				<ExtendedSelectionGroupWrapper withImage type="multi-select" items={filteredItems} />
			</StyledInteriorPackageContainer>
		</>
	);
};
